import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type TenantEmailSenderFragment = { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean };

export type TenantEmailSenderRowFragment = { __typename?: 'TenantEmailSenderDocument', id: string, senderId: string, email: string, displayName: string, verificationMethod: Types.EmailSenderVerificationMethod, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean, addedAt: Types.TDateISO, updatedAt: Types.TDateISO };

export type GetTenantEmailSendersQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  order?: Types.InputMaybe<Array<Types.TenantEmailSenderDocumentSortInput> | Types.TenantEmailSenderDocumentSortInput>;
}>;


export type GetTenantEmailSendersQuery = { __typename?: 'Query', tenantEmailSenders?: { __typename?: 'TenantEmailSendersConnection', totalCount: number, nodes?: Array<{ __typename?: 'TenantEmailSenderDocument', id: string, senderId: string, email: string, displayName: string, verificationMethod: Types.EmailSenderVerificationMethod, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean, addedAt: Types.TDateISO, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetSelectableEmailSendersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSelectableEmailSendersQuery = { __typename?: 'Query', selectableEmailSenders: Array<{ __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean }> };

export type GetEffectiveEmailSenderQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEffectiveEmailSenderQuery = { __typename?: 'Query', effectiveEmailSender: { __typename?: 'TenantEmailSenderData', isPlatformDefault: boolean, senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean } };

export type GetTenantEmailSenderSelectionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantEmailSenderSelectionQuery = { __typename?: 'Query', tenantEmailSenderSelection: { __typename?: 'TenantEmailSenderSelectionData', configured: { __typename?: 'EmailSenderSelectionData', kind: Types.EmailSenderSelectionKind, intendedUse: Types.EmailSenderIntendedUse, revision: number, companySender?: { __typename?: 'SelectedCompanySenderData', channel: Types.EmailSenderChannel, email: string } | null }, effective: { __typename?: 'EffectiveEmailSenderRouteData', replyToEmail: string, replyRouting: Types.EmailReplyRouting, intendedUse: Types.EmailSenderIntendedUse, readiness: Types.EmailSenderReadiness, sender: { __typename?: 'TenantEmailSenderData', isPlatformDefault: boolean, senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean } } } };

export type GetSenderDomainPolicyQueryVariables = Types.Exact<{
  domain: Types.Scalars['String']['input'];
}>;


export type GetSenderDomainPolicyQuery = { __typename?: 'Query', senderDomainPolicy: { __typename?: 'SenderDomainPolicyData', dmarcPolicy?: Types.EmailDmarcPolicy | null, spfStrict?: boolean | null, isDomainAuthenticated?: boolean | null } };

export const TenantEmailSenderFragmentDoc = new TypedDocumentString(`
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}
    `, {"fragmentName":"TenantEmailSender"});
export const TenantEmailSenderRowFragmentDoc = new TypedDocumentString(`
    fragment TenantEmailSenderRow on TenantEmailSenderDocument {
  id
  senderId
  email
  displayName
  verificationMethod
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
  addedAt
  updatedAt
}
    `, {"fragmentName":"TenantEmailSenderRow"});
export const GetTenantEmailSendersDocument = new TypedDocumentString(`
    query GetTenantEmailSenders($first: Int, $order: [TenantEmailSenderDocumentSortInput!]) {
  tenantEmailSenders(first: $first, order: $order) {
    nodes {
      ...TenantEmailSenderRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment TenantEmailSenderRow on TenantEmailSenderDocument {
  id
  senderId
  email
  displayName
  verificationMethod
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
  addedAt
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetSelectableEmailSendersDocument = new TypedDocumentString(`
    query GetSelectableEmailSenders {
  selectableEmailSenders {
    ...TenantEmailSender
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
export const GetEffectiveEmailSenderDocument = new TypedDocumentString(`
    query GetEffectiveEmailSender {
  effectiveEmailSender {
    ...TenantEmailSender
    isPlatformDefault
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
export const GetTenantEmailSenderSelectionDocument = new TypedDocumentString(`
    query GetTenantEmailSenderSelection {
  tenantEmailSenderSelection {
    configured {
      kind
      intendedUse
      revision
      companySender {
        channel
        email
      }
    }
    effective {
      sender {
        ...TenantEmailSender
        isPlatformDefault
      }
      replyToEmail
      replyRouting
      intendedUse
      readiness
    }
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
export const GetSenderDomainPolicyDocument = new TypedDocumentString(`
    query GetSenderDomainPolicy($domain: String!) {
  senderDomainPolicy(domain: $domain) {
    dmarcPolicy
    spfStrict
    isDomainAuthenticated
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTenantEmailSenders: build.query<GetTenantEmailSendersQuery, GetTenantEmailSendersQueryVariables | void>({
      query: (variables) => ({ document: GetTenantEmailSendersDocument, variables })
    }),
    GetSelectableEmailSenders: build.query<GetSelectableEmailSendersQuery, GetSelectableEmailSendersQueryVariables | void>({
      query: (variables) => ({ document: GetSelectableEmailSendersDocument, variables })
    }),
    GetEffectiveEmailSender: build.query<GetEffectiveEmailSenderQuery, GetEffectiveEmailSenderQueryVariables | void>({
      query: (variables) => ({ document: GetEffectiveEmailSenderDocument, variables })
    }),
    GetTenantEmailSenderSelection: build.query<GetTenantEmailSenderSelectionQuery, GetTenantEmailSenderSelectionQueryVariables | void>({
      query: (variables) => ({ document: GetTenantEmailSenderSelectionDocument, variables })
    }),
    GetSenderDomainPolicy: build.query<GetSenderDomainPolicyQuery, GetSenderDomainPolicyQueryVariables>({
      query: (variables) => ({ document: GetSenderDomainPolicyDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTenantEmailSendersQuery, useLazyGetTenantEmailSendersQuery, useGetSelectableEmailSendersQuery, useLazyGetSelectableEmailSendersQuery, useGetEffectiveEmailSenderQuery, useLazyGetEffectiveEmailSenderQuery, useGetTenantEmailSenderSelectionQuery, useLazyGetTenantEmailSenderSelectionQuery, useGetSenderDomainPolicyQuery, useLazyGetSenderDomainPolicyQuery } = injectedRtkApi;
